import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=4c0a001c&scoped=true"
import script from "./ProductActions.vue?vue&type=script&lang=ts"
export * from "./ProductActions.vue?vue&type=script&lang=ts"
import style0 from "./ProductActions.vue?vue&type=style&index=0&id=4c0a001c&prod&lang=scss&scoped=true"
import style1 from "./ProductActions.vue?vue&type=style&index=1&id=4c0a001c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a001c",
  null
  
)

export default component.exports